import Vue from 'vue'

export default el => Promise.all([
  enqueueModule('vue-flickity.vue')
]).then(() => new Vue({
  el,
  data () {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: this.showDots || false,
        cellAlign: 'left',
        freeScroll: false,
        wrapAround: false,
        contain: true,
        groupCells: true
      }
    }
  }
}))
